import { z } from 'zod';
import { Experience } from '../../../../types/experience';

export const DetailsSchema = z.object({
    name: z
        .string()
        .min(1, { message: 'Required' })
        .max(25, { message: 'Character limit reached' }),
    description: z
        .string()
        .min(1, { message: 'Required' })
        .max(500, { message: 'Character limit reached' }),
    visitType: z.enum(['personal', 'business']),
    notificationsEmail: z.string().email().or(z.literal('')),
});

const DetailsSchemaPartial = DetailsSchema.extend({
    name: z.string(),
    description: z.string(),
}).partial();

const validateName = (
    name: string,
    experience: Experience,
    allAssets: Experience[],
) => {
    const existingNames = allAssets
        .filter((asset) => asset.id !== experience.id)
        .map((asset) => asset.name?.toLowerCase().trim());
    if (existingNames.includes(name.toLowerCase().trim())) {
        return false;
    }
    return true;
};

export const getDetailsSchema = (
    experience: Experience,
    allAssets: Experience[],
) => {
    return DetailsSchema.superRefine((val, ctx) => {
        if (!validateName(val.name, experience, allAssets)) {
            ctx.addIssue({
                path: ['name'],
                code: z.ZodIssueCode.custom,
                message: 'Name must be unique',
            });
        }
    });
};

export const getDetailsSchemaPartial = (
    experience: Experience,
    allAssets: Experience[],
) => {
    return DetailsSchemaPartial.superRefine((val, ctx) => {
        if (val.name && !validateName(val.name, experience, allAssets)) {
            ctx.addIssue({
                path: ['name'],
                code: z.ZodIssueCode.custom,
                message: 'Name must be unique',
            });
        }
    });
};
